import React from 'react';
import { connect } from 'react-redux';
import DynamicformInit from "../DynamicformInit";
import DynamicFormControls from "../DynamicForm/DynamicFormControls";
import { updateData, resetFormData } from "../../redux/actions/formsAction";
import { OverlayTrigger, Popover } from 'react-bootstrap';
const _ = require("lodash");

function mapStateToProps(state) {
    return {
        token: state.formLoginReducer.token,
        data: state.formDataReducer,
        hasErrored: state.formDataReducer.hasErrored,
        isLoading: state.formDataReducer.isLoading
    };
}
function bindAction(dispatch) {
    return {
        resetData: (data, storekey) => dispatch(resetFormData(data, storekey)),
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
    };
}
class Panel extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            show: true,
            morebuttonpopup: false,
            modelData: null
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var apiData = nextProps.data[nextProps.formid + nextProps.action] ? nextProps.data[nextProps.formid + nextProps.action] : {};
        if (apiData && apiData[nextProps.control.key + '_refresh'] != prevState.modelData) {
            return {
                modelData: apiData[nextProps.control.key + '_refresh'],
            };
        } else return null; // Triggers no change in the state
    }
    componentDidUpdate(prevProps, prevState) {
        const { control, formid } = this.props;
        if (typeof this.state.modelData == 'string' && prevState.modelData != this.state.modelData) {
            debugger;
            if (control.defaultCollapse && !control.isnotcollapsible) {
                this.setState({ show: false })
            }
            if (control.IsExternalFormLoad) {
                if (!control.isbindwithapi) {
                    var data = this.props.data[this.props.formid + this.props.action] ? this.props.data[this.props.formid + this.props.action][control.key] : {};

                    this.props.resetData(data, control.formid + control.formactiontype);
                }
            } else {
                var datamodel = this.props.data[this.props.formid + this.props.action] ? this.props.data[this.props.formid + this.props.action] : {};

                // ControlService().GenerateDataJson(control.children, datamodel, null, true);
                control.children.map(ctrl => {
                    delete datamodel[ctrl.key];
                })
                delete datamodel[control.key + '_refresh'];

                this.props.resetData(datamodel, this.props.formid + this.props.action);
            }
        }
        if (control.IsExternalFormLoad) {
            if (!control.isbindwithapi) {
                debugger;
                var nextData = this.props.data[this.props.control.formid + this.props.control.formactiontype] ? this.props.data[this.props.control.formid + this.props.control.formactiontype] : null;
                var currData = this.props.data[this.props.formid + this.props.action] ? this.props.data[this.props.formid + this.props.action][this.props.control.key] : {};

                if (nextData && !_.isEqual(nextData, currData)) {
                        this.props.update(control.key, nextData, this.props.formid + this.props.action);
                }
            }
        }
    }
    componentDidMount() {
        if (this.props.control.defaultCollapse && !this.props.control.isnotcollapsible) {
            this.setState({ show: false })
        }
        if (this.props.control.IsExternalFormLoad && !this.props.control.isbindwithapi) {
            var data = this.props.data[this.props.formid + this.props.action] ? this.props.data[this.props.formid + this.props.action][this.props.control.key] : {};

            this.props.resetData(data, this.props.control.formid + this.props.control.formactiontype);
        }
    }
    toggle() {
        this.setState({
            show: !this.state.show
        });
    }
    render() {
        const { control, action, formid } = this.props;
        var data = this.props.data[formid + action] ? this.props.data[formid + action] : {};
        var children = control.children.map((item, i) => {
            return (
                <DynamicFormControls key={item.id} formid={formid} control={item} action={action} />
            )
        });
        // let icon = this.icons['down'];

        // if (this.state.expanded) {
        //     icon = this.icons['up'];
        // }
        // console.log(JSON.stringify(control))
        return (
            <React.Fragment>
                {(!control.ismorebutton && !control.IsExternalFormLoad) &&
                    <div style={{ borderRadius: control.borderRadius, overflow: (control.borderRadius ? 'hidden' : 'initial') }} id={control.key} className={'card mb-3 ' + (control.panelclass ? control.panelclass : control.panalclass) + ' ' + (control.hideborder && 'border-0')}>
                        {(control.showheader == true && control.isnotcollapsible == false) &&
                            <div onClick={this.toggle.bind(this)} style={{ backgroundColor: control.headerBg, color: control.headerTextColor }} className={'card-header ' + control.panelBg + ' ' + control.panelTextColor}>
                                <div className='row align-items-center'>
                                    <div className={"col " + control.headerTextAlign}>
                                        {control.WebIcon ? <i className={"pr-2 " + control.WebIcon}></i> : null}
                                        <span>{control.label}</span>
                                    </div>
                                    {this.state.show ?
                                        <div className='col-auto'>
                                            <i className="fa fa-angle-up" aria-hidden="true"></i>
                                        </div>
                                        :
                                        <div className='col-auto'>
                                            <i className="fa fa-angle-down" aria-hidden="true"></i>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        {(control.showheader == true && control.isnotcollapsible == true) &&
                            <div style={{ backgroundColor: control.headerBg, color: control.headerTextColor }} className={'card-header ' + control.panelBg + ' ' + control.panelTextColor}>
                                <div className='row align-items-center'>
                                    <div className={"col " + control.headerTextAlign}>
                                        {control.WebIcon ? <i className={"pr-2 " + control.WebIcon}></i> : null}
                                        <span>{control.label}</span>
                                    </div>
                                </div>
                            </div>
                        }
                        <div style={{
                            backgroundImage: `url(${control.backgroundImage})`,
                            backgroundPosition: control.backgroundposition,
                            backgroundRepeat: control.backgroundrepeat,
                            backgroundSize: control.backgroundsize,
                            backgroundColor: (control.backgroundcolor ? control.backgroundcolor : 'transparent'),
                            overflow: (control.height > 0 ? 'auto' : ''),
                            overflowX: (control.height > 0 ? 'hidden' : ''),
                            height: control.height
                        }}
                            className={'card-body ' + (this.state.show ? '' : 'd-none') + ' ' + (control.panelbodyclass ? control.panelbodyclass : '') + ' ' + (control.removePadding && 'px-0 pb-0')}>
                            {control.Subheader && <label>{control.Subheader}</label>}

                            <div className="row">

                                {children}
                            </div>
                        </div>
                    </div>
                }
                {control.ismorebutton &&
                    <OverlayTrigger
                        trigger="click"
                        rootClose
                        placement={'auto'}
                        overlay={
                            <Popover id={control.key}>
                                <Popover.Content className=''>
                                    <div className="row">
                                        {children}
                                    </div>
                                </Popover.Content>
                            </Popover>
                        }
                    >
                        <button aria-label='More' className={'btn ' + control.customclass}>
                            {control.Icon && <i className={control.Icon + (control.label ? ' mr-2' : '')}></i>}
                            {control.bindlabelwithdata ? data[control.label] : control.label}
                        </button>
                    </OverlayTrigger>
                }
                {
                    control.IsExternalFormLoad &&
                    <div style={{ borderRadius: control.borderRadius, overflow: (control.borderRadius ? 'hidden' : 'initial') }} id={control.key} className={'card mb-3 ' + (control.panelclass ? control.panelclass : control.panalclass) + ' ' + (control.hideborder && 'border-0')}>
                        {(control.showheader == true && control.isnotcollapsible == false) &&
                            <div onClick={this.toggle.bind(this)} style={{ backgroundColor: control.headerBg, color: control.headerTextColor }} className={'card-header ' + control.panelBg + ' ' + control.panelTextColor}>
                                <div className="row align-items-center">
                                    <div className={"col " + control.headerTextAlign}>
                                        {control.WebIcon ? <i className={"pr-2 " + control.WebIcon}></i> : null}
                                        <span>{control.label}</span>
                                    </div>

                                    {this.state.show ?
                                        <div className="col-auto" >
                                            <i className="fa fa-angle-up" aria-hidden="true"></i>
                                        </div>
                                        :
                                        <div className="col-auto">
                                            <i className="fa fa-angle-down" aria-hidden="true"></i>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        {(control.showheader == true && control.isnotcollapsible == true) &&
                            <div style={{ backgroundColor: control.headerBg, color: control.headerTextColor }} className={'card-header ' + control.panelBg + ' ' + control.panelTextColor}>
                                <div className="row align-items-center">
                                    <div className={"col " + control.headerTextAlign}>
                                        {control.WebIcon ? <i className={"pr-2 " + control.WebIcon}></i> : null}
                                        <span>{control.label}</span>
                                    </div>
                                </div>
                            </div>
                        }
                        <div style={{
                            backgroundImage: `url(${control.backgroundImage})`,
                            backgroundPosition: control.backgroundposition,
                            backgroundRepeat: control.backgroundrepeat,
                            backgroundSize: control.backgroundsize,
                            backgroundColor: (control.backgroundcolor ? control.backgroundcolor : 'transparent'),
                            overflow: (control.height > 0 ? 'auto' : ''),
                            overflowX: (control.height > 0 ? 'hidden' : ''),
                            height: control.height
                        }}
                            className={'card-body ' + (this.state.show ? '' : 'd-none') + ' ' + (control.panelbodyclass ? control.panelbodyclass : '') + ' ' + (control.removePadding && 'px-0 pb-0')}>
                            {control.Subheader && <label>{control.Subheader}</label>}

                            <DynamicformInit
                                formid={control.formid}
                                dataid={''}
                                formui={null}
                                datamodel={control.isbindwithapi ? null : data[control.key]}
                                access={control.formactiontype ? control.formactiontype : 'write'}
                                pageparams={{}}
                                authtoken={this.props.token} />
                        </div>
                    </div>
                }
            </React.Fragment >
        );
    }
}

export default connect(
    mapStateToProps, bindAction
)(Panel);